<template>
  <div v-if="shifts.length" class="rm-chip-row gm-chips" role="group" :aria-label="$t('shifts')">
    <button
      v-for="shift in shifts"
      :key="shift"
      type="button"
      class="rm-chip"
      :class="{ 'rm-chip--active': value === shift }"
      :aria-pressed="String(value === shift)"
      @click="$emit('input', shift)"
    >
      <report-shift-tag :shift="Number(shift)" long></report-shift-tag>
    </button>
  </div>
</template>

<script>
import ReportShiftTag from "../../../shared/ReportShiftTag.vue";

/** Izbor jedne smene (oznake smena u boji) za izveštaje koji se čitaju za jednu smenu: Naručeno i Naručioci. */
export default {
  name: "GroupMobileShiftChips",
  components: { ReportShiftTag },
  props: {
    /** Smene koje imaju podatke */
    shifts: { type: Array, default: () => [] },
    value: { type: Number, default: null },
  },
};
</script>
